export default {
  PRODUCT_TEMPLATE: '/product/template',
};
